import { ISessionData } from "../../../types/session.type";
import { store } from "../../../store/store";
import { setSessionData } from "../../../store/slices/session.slice";

// Сохранение данных сессии в кэш
export const setSessionDataInState = ({
	count,
	messages,
	ok,
	previous_session_id,
	session_id,
	type,
}: ISessionData) => {
	const data = {
		count,
		messages,
		ok,
		previous_session_id,
		session_id,
		type,
	};
	// Записываем полученные данные в Redux
	store.dispatch(setSessionData(data));
};
